'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var reactHookForm = require('react-hook-form');
var Form_Checkbox = require('../Form.Checkbox/Form.Checkbox.js');
var Form_Combobox = require('../Form.Combobox/Form.Combobox.js');
var Form_Context = require('../Form.Context/Form.Context.js');
var Form_DatePicker = require('../Form.DatePicker/Form.DatePicker.js');
var Form_DatePicker_Preset = require('../Form.DatePicker.Preset/Form.DatePicker.Preset.js');
var Form_DatePicker_PresetRange = require('../Form.DatePicker.PresetRange/Form.DatePicker.PresetRange.js');
var Form_Dropdown = require('../Form.Dropdown/Form.Dropdown.js');
var Form_Input = require('../Form.Input/Form.Input.js');
var Form_MoneyInput = require('../Form.MoneyInput/Form.MoneyInput.js');
var Form_MultiSelectCombobox = require('../Form.MultiSelectCombobox/Form.MultiSelectCombobox.js');
var Form_OptionsContext = require('../Form.OptionsContext/Form.OptionsContext.js');
var Form_PasswordInput = require('../Form.PasswordInput/Form.PasswordInput.js');
var Form_SelectCard = require('../Form.SelectCard/Form.SelectCard.js');
var Form_SubmitButton = require('../Form.SubmitButton/Form.SubmitButton.js');
var Form_Textarea = require('../Form.Textarea/Form.Textarea.js');

/**
 * Create Form Component.
 */ function createForm(context, options) {
    const Form = ({ children, onSubmit, isActionSubmit, id, ...props })=>{
        const { onFormSubmit } = react.useContext(Form_Context.FormContext);
        // - Handle form submit
        // - prevent default action unless isActionSubmit is explicitly set
        const handleSubmit = react.useCallback((e)=>{
            if (!isActionSubmit) {
                e.preventDefault();
                /**
                 * We want to invoke the optional onSubmit hook, whenever a form gets submitted.
                 */ const composedOnSubmit = (data, event)=>{
                    void Promise.resolve(onFormSubmit?.(data, id));
                    return onSubmit?.(data, event);
                };
                void context.handleSubmit(composedOnSubmit)(e);
            }
        }, [
            id,
            isActionSubmit,
            onFormSubmit,
            onSubmit
        ]);
        return jsxRuntime.jsx(reactHookForm.FormProvider, {
            ...context,
            children: jsxRuntime.jsx(Form_OptionsContext.FormOptionsProvider, {
                options: options,
                children: jsxRuntime.jsx("form", {
                    ...props,
                    onSubmit: handleSubmit,
                    children: children
                })
            })
        });
    };
    Form.Checkbox = Form_Checkbox.createFormCheckbox();
    Form.Combobox = Form_Combobox.createFormCombobox();
    Form.DatePicker = Form_DatePicker.createFormDatePicker();
    Form.DatePickerPreset = Form_DatePicker_Preset.createFormDatePickerPreset();
    Form.DatePickerPresetRange = Form_DatePicker_PresetRange.createFormDatePickerPresetRange();
    Form.Dropdown = Form_Dropdown.createFormDropdown();
    Form.Input = Form_Input.createFormInput();
    Form.MoneyInput = Form_MoneyInput.createFormMoneyInput();
    Form.MultiSelectCombobox = Form_MultiSelectCombobox.createFormMultiSelectCombobox();
    Form.PasswordInput = Form_PasswordInput.createFormPasswordInput();
    Form.SubmitButton = Form_SubmitButton.createFormSubmitButton();
    Form.Textarea = Form_Textarea.createFormTextarea();
    Form.SelectCard = Form_SelectCard.createFormSelectCard();
    Form.displayName = 'Form';
    return Form;
}

exports.createForm = createForm;
//# sourceMappingURL=Form.js.map
